import classNames from 'classnames'
import React from 'react'
import { Trans } from '@lingui/macro'
import { Box, Flex, Heading, Text, BackButton } from 'front-end/src/components'
import { HeadingProps } from '@chakra-ui/react'
import { css } from '@emotion/react'
import { brandColors } from 'shared/basicPalette'
import { HeadTitle } from '../../head/HeadTitle'

import './PageHeader.less'
import { sizes } from 'front-end/src/components/chakraThemeExtension'

export type HeaderLevelType = 1 | 2 | 3 | 4 | 5 | 6

const PageHeader = ({
  className,
  showBackButton = true,
  defaultBackButtonPath,
  level = 1,
  title,
  titleRawText,
  titleFollowers,
  controls,
  subHeader,
  children,
  fullWidth = false,
  ...rest
}: Omit<HeadingProps, 'title'> & {
  className?: string
  showBackButton?: boolean
  fullWidth?: boolean
  defaultBackButtonPath?: string
  level?: HeaderLevelType
  title: React.ReactElement<any> | string | null | undefined
  titleRawText?: string
  titleFollowers?: React.ReactElement<any>
  controls?: React.ReactElement<any> | null | undefined
  subHeader?: React.ReactElement<any> | string | null | undefined
  children?: React.ReactElement<any>
}) => {
  const classes = classNames(
    'Header',
    { 'Header--with-back': showBackButton },
    className
  )

  return (
    <>
      {titleRawText ? (
        <HeadTitle title={titleRawText} />
      ) : (
        <>{typeof title === 'string' && <HeadTitle title={title} />}</>
      )}
      <Box
        as="header"
        className={classes}
        maxW={fullWidth ? '100%' : sizes.container.lg}
        mx="auto"
      >
        <Flex className="Header__main">
          <Heading
            as={`h${level}`}
            css={css`
              flex-grow: 1;
            `}
            {...rest}
          >
            {showBackButton && (
              <BackButton
                className="Header__back"
                defaultPath={defaultBackButtonPath}
                variant="link"
              >
                <Text className="Header__back__text">
                  <Trans>Back</Trans>
                </Text>
              </BackButton>
            )}
            {title && <Flex className="Header__title">{title}</Flex>}
            {titleFollowers && (
              <Flex
                className="Header__titleFollowers"
                direction="column"
                justifyContent="center"
                css={css`
                  .IconSettings {
                    font-size: 20px;
                    color: ${brandColors.grey.mid};
                  }
                `}
              >
                {titleFollowers}
              </Flex>
            )}
          </Heading>

          {controls && <Box className="Header__controls">{controls}</Box>}
          {children}
        </Flex>
        {subHeader && <Box className="Header__subheader">{subHeader}</Box>}
      </Box>
    </>
  )
}

export default PageHeader
